import { FC, ReactNode } from 'react';

import { Box, Flex, Heading, Stack } from '@chakra-ui/react';

export const SectionCard: FC<{
  title?: string;
  titleCentered?: boolean;
  iconSlot?: ReactNode;
  descriptionSlot?: ReactNode;
  actionSlot?: ReactNode;
  footerSlot?: ReactNode;
  children: ReactNode;
}> = ({ title, titleCentered, iconSlot, descriptionSlot, actionSlot, footerSlot, children }) => {
  return (
    <Stack as='section' p={{ base: 4, lg: 8 }} spacing={8} bgColor='white' borderRadius='xl'>
      <Box>
        <Stack spacing={4}>
          <Flex
            as='header'
            justifyContent={titleCentered ? 'center' : 'space-between'}
            alignItems='center'
            gap={4}
            flexDir={{ base: 'column', sm: 'row' }}
          >
            <Flex alignItems='center' gap={4}>
              {iconSlot}
              {title && (
                <Heading as='h1' size='h1'>
                  {title}
                </Heading>
              )}
            </Flex>
            {actionSlot}
          </Flex>
          {descriptionSlot && <Box>{descriptionSlot}</Box>}
        </Stack>
      </Box>
      {children}
      {footerSlot && <Box as='footer'>{footerSlot}</Box>}
    </Stack>
  );
};
